import { ca } from '@cian/analytics';

export const trackHeaderPinFilterClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click',
    label: 'PinnedSearch',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};
